import ScrollMagic from 'scrollmagic'
import { mount } from 'svelte';
import Questionnaire from './js/Questionnaire.svelte'

let _ = jQuery.noConflict()

let projectFilters = {
    'category': [],
    'location': [],
    'year': [],
    'search': ''
}

let projectFiltersBlank = {
    'category': [],
    'location': [],
    'year': [],
    'search': ''
}

_(document).ready(function() {
    if(_('#axis-pricing-tool-app').length > 0) {
        mount(Questionnaire, {
            target: document.getElementById('axis-pricing-tool-app'),
        });
    }

    if(_('.sm-hero-trigger').length > 0) {
        _(this).stickyHeader()
    }

    if(_('.axis-featured-projects').length > 0) {
        _(this).featuredProjects()
    }

    function filterProjectSearch(e) {
        projectFilters.search = _('#filter-search').val().toLowerCase()
        _(this).setProjectFilters()
    }

    _('.search-button').on('click', function(e) {
        filterProjectSearch(e)
    })

    _('input[type="search"]').on('keydown', function(e) {
        if(e.which === 13 && window.location.pathname.indexOf('/projects') > 0) {
            e.preventDefault()

            filterProjectSearch(e)
        }
    })

    if(_('.axis-archive-projects-filter')) {
        _('.filter-reset-button').addClass('hidden');

        _('.filter-reset-button').on('click', function(e) {
            _('.axis-multi-picker').each(function(){
                _(this).val(null).trigger('change')
            })

            projectFilters.search = ''
            _('#filter-search').val('')
            _(this).setProjectFilters()

            _(this).addClass('hidden')
        })

        if(projectFilters.category.length > 0 || projectFilters.location.length > 0 || projectFilters.year.length > 0 || projectFilters.search.length > 0) {
            _('.filter-reset-button').removeClass('hidden');
        }

        _('.axis-multi-picker').each(function() {
            let dt = _('dt', _(this).parent().parent())
            let label = _('label', dt).text()

            _(this).select2({
                placeholder: 'Select a ' + label.toLowerCase()
            })
        })

        _('.axis-multi-picker').on('change', function (e) {
            let data = _(this).select2('data')
            let name = _(this).attr('name').replace('[]', '')

            if(data.length > 0) {
                projectFilters[name] = []

                for (let i = 0; i < data.length; i++) {
                    projectFilters[name].push(data[i].id)
                }
            } else {
                projectFilters[name] = []
            }

            _(this).setProjectFilters()
        })

        _(this).setProjectFiltersFromURLParams()
    }
})

_.fn.stickyHeader = function() {
    let controller = new ScrollMagic.Controller()
    new ScrollMagic.Scene({triggerElement: ".sm-hero-trigger"})
        .setClassToggle("header", "scrolled")
        .addTo(controller)
}

_.fn.featuredProjects = function() {
    new Splide(
        '.axis-featured-projects .splide',
        {
            type: 'loop',
            perPage: 2,
            perMove: 1,
            snap: 1,
            flickMaxPages: 1,
            flickPower: 10,
            focus: "center",
            trimSpace: 1,
            gap: "4rem",
            pagination: 0,
            drag: true,
            breakpoints: {
                "768": {
                    perPage: 1,
                    focus: 0,
                    trimSpace: 0
                }
            }
        }
    ).mount()

    new Splide(
        '.axis-featured-testimonials .splide',
        {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            snap: 1,
            flickMaxPages: 1,
            flickPower: 10,
            focus: "center",
            trimSpace: 1,
            gap: "4rem",
            pagination: 0,
            drag: true,
            breakpoints: {
                "768": {
                    perPage: 1,
                    focus: 0,
                    trimSpace: 0
                }
            }
        }
    ).mount()
}

_.fn.setProjectFilters = function() {
    let params = []

    if(projectFilters.category.length > 0) {
        params.push('project_category=' + projectFilters.category.join(','))
    }

    if(projectFilters.location.length > 0) {
        params.push('project_location=' + projectFilters.location.join(','))
    }

    if(projectFilters.year.length > 0) {
        params.push('project_year=' + projectFilters.year.join(','))
    }

    if(projectFilters.search.length > 0) {
        params.push('search=' + projectFilters.search)
    }

    let paramString = '?' + params.join('&').toString()

    window.history.pushState({path: window.location.pathname}, '', window.location.pathname + paramString)

    _(this).filterProjects()
}

_.fn.setProjectFiltersFromURLParams = function() {
    if(window.location.pathname.indexOf('/projects') > 0) {
        let params = window.location.search.substring(1)

        let values = params.split('&').reduce(function (res, item) {
            let parts = item.split('=')
            res[parts[0]] = parts[1]
            return res
        }, {})

        _('.axis-multi-picker').each(function (e) {
            let name = _(this).attr('name').replace('[]', '')

            if (values['project_' + name]) {
                _(this).val(values['project_' + name].split(',')).trigger('change.select2')
                projectFilters[name] = values['project_' + name].split(',')
            }
        })

        if (values.search && values.search.length > 0) {
            _('.axis-project-search').val(values.search)
            projectFilters.search = values.search
        }

        _(this).filterProjects()
    }
}

_.fn.filterProjects = function() {
    if(projectFilters.category.length > 0 || projectFilters.location.length > 0 || projectFilters.year.length > 0 || projectFilters.search.length > 0) {
        _('.filter-reset-button').removeClass('hidden');
    }

    _('.axis-archive-project').each(function(e) {
        _(this).addClass('hidden')

        let categories = _(this).attr('data-category').split(',')
        let locations = _(this).attr('data-locations').split(',')
        let year = _(this).attr('data-year').split(',')
        let title = _('h3', this).html().toLowerCase()

        let matchingCategories = 0
        let matchingLocations = 0
        let matchingYears = 0
        let matchingSearch = false

        for(let i = 0; i < categories.length; i++) {
            if(projectFilters.category.includes(categories[i])) {
                matchingCategories++
            }
        }

        for(let i = 0; i < locations.length; i++) {
            if(projectFilters.location.includes(locations[i])) {
                matchingLocations++
            }
        }

        for(let i = 0; i < year.length; i++) {
            if(projectFilters.year.includes(year[i])) {
                matchingYears++
            }
        }

        if(projectFilters.search.length === 0 || title.includes(projectFilters.search.toLowerCase())) {
            matchingSearch = true
        }

        if(
            projectFilters.category.length === matchingCategories &&
            projectFilters.location.length === matchingLocations &&
            projectFilters.year.length === matchingYears &&
            matchingSearch
        ){
            _(this).removeClass('hidden')
        }
    })
}